<template>
    <div>
        <div class="title mb-4">
            Enturmação de Alunos
            <helper-gdb text="Atualização de CODTURMA no período letivo para alunos sem CODTURMA parametrizada no período letivo vigente."/>
        </div>
        <v-row>
            <v-col cols="12" sm="6">
                <v-select :items="pletivos"
                    item-value="idperlet" item-title="codperlet"
                    label="Selecione IdPerlet"
                    :loading="StateInfoAlunoLoading" :disabled="StateInfoAlunoLoading"
                    @update:modelValue="onChangeIdperlet" v-model="idperlet"
                    hint="Período Letivo em que deve ocorrer a inclusão de turma"
                    persistent-hint
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
                <v-autocomplete :items="sturmas"
                    v-show="!!idperlet"
                    :loading="StateInfoAlunoLoading"
                    :disabled="StateInfoAlunoLoading"
                    item-value="codturma" item-title="descricao" label="Selecione uma turma"
                    :hint="idperlet ? `Se o código da turma não for exibido, deve-se verificar junto à SECAD sobre a inclusão da turma no período idperlet ${idperlet}`: ''"
                    persistent-hint
                     v-model="codturma"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12">
                <v-autocomplete clearable chips
                    multiple
                    v-model="matriculas"
                    :items="lista_ra"
                    :loading="StateInfoAlunoLoading"
                    :disabled="StateInfoAlunoLoading"
                    item-title="descricao" item-value="ra"
                    hint="Selecione as matrículas, pressionar ENTER ou vírgula(,). Somente Alunos Matriculados serão listados"
                    persistent-hint label="Matrículas"
                    v-show="!!idperlet"
                    >
                    <template v-slot:selection="{ attrs, item }">
                        <v-chip v-bind="attrs" label close color="primary" @click:close="remove(item)" small>
                            <strong>👨🏼‍🎓 {{ item.ra }}</strong> &nbsp;
                        </v-chip>
                    </template>
                    <template v-slot:append-outer>
                        <v-btn v-show="!!idperlet" small icon @click="get_lista_ra(idperlet)">
                            <v-icon small>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12">
                <v-btn @click.stop="enturmar"
                :disabled="!idperlet || !codturma || (matriculas||'').length == 0"
                >Enturmar {{matriculas.length}} aluno{{matriculas.length == 1 ? '': 's'}}</v-btn>
            </v-col>
            <v-col cols="12" sm="12">
                <span v-for="l, index in log" :key="index">
                    <v-alert
                        border="left"
                        close-text="Close Alert"
                        color="primary">
                        {{l}}
                    </v-alert>
                </span>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'EnturmarComponent',
    data:()=>({
        matriculas:[],
        codturma:null,
        idperlet:null,
        pletivos:[],
        sturmas:[],
        log:[],
        lista_ra:[]
    }),
    methods:{
        ...mapActions(['Enturmar',
                        'GetListaRAEnturmacao',
                        'GetCadernoFormando',
                        'GetPletivosEnturmacao',
                        'GetTurmasEnturmacao']),
        async get_pletivos(){
            const response = await this.GetPletivosEnturmacao()
            this.pletivos = response.data
        },
        async get_turmas(idperlet){
            const response = await this.GetTurmasEnturmacao({idperlet})
            this.sturmas = response.data
        },
        async get_lista_ra(idperlet){
            const response = await this.GetListaRAEnturmacao({idperlet})
            this.lista_ra = response.data
        },
        async onChangeIdperlet(value){
            await this.get_turmas(value)
            await this.get_lista_ra(value)
        },
        async enturmar(){
            if (!this.matriculas.length || !this.codturma || !this.idperlet){
                alert('Verifique se todos os campos foram informados!')
            }
            const data = {
                matriculas:this.matriculas,
                codturma: this.codturma,
                idperlet: this.idperlet
            }
            const response = await this.Enturmar(data)
            if(response.status == 200){
                this.log = response.data
                this.matriculas = []
            }else{
                this.log = 'Falha ao Enturmar'
                alert(response.statusText)
            }
        },
        remove(item) {
            this.matriculas.splice(this.matriculas.indexOf(item.ra), 1);
            this.matriculas = [...this.matriculas];
        },
    },
    computed:{
        ...mapGetters(['StateInfoAlunoLoading'])
    },
    mounted(){
        let y = new Date().getFullYear()
        let m = new Date().getMonth()+1
        this.codperlet = `${y}${(m > 6 ? '.2' : '.1')}`
        this.get_pletivos()
    }
}
</script>
<style scoped>
.cell-text{
    font-size: 11px;
}
</style>
<style>
tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .03);
}
.datatable_caderno_formando tbody{
    vertical-align: text-top !important;
}
.datatable_caderno_formando tbody tr td,.datatable_caderno_formando thead tr th{
    padding: 5px !important;
}
</style>